import DataSourceDetailActionsContainer from 'js/components/data_sources/cards/DataSourceDetailActionsContainer';
import { useDrawerContext } from 'new/components/drawer/useDrawerContext';
import { Table } from 'new/elements/Table';
import { useMySources } from 'new/hooks/adapters/useMySources';
import React from 'react';
import './SourcesTable.module.scss';
import { columns } from './columns';

interface FlowsTableProps {
  orgId: number;
  shared: 'me' | 'to';
  height: number;
}

export function SourcesTable(props: FlowsTableProps) {
  const { sources } = useMySources();
  const { drawerContentRef } = useDrawerContext();

  const rowEndRender = (row) => {
    if (!row) {
      return null;
    }
    return (
      <DataSourceDetailActionsContainer
        data={row}
        showStatus={false}
        horizontalDots
        readOnly={row.readOnly}
        isManaged={row.isManaged}
        connectionOrVendorType={row.connectionOrVendorType}
      />
    );
  };

  return (
    <Table
      parentScrollRef={drawerContentRef}
      rowEndRender={rowEndRender}
      columns={columns}
      rows={sources}
    />
  );
}
